var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQ4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3107 24.7966H12.335L17.609 22.1527V5.20361L12.3107 7.85451V24.7966ZM4.73368 5.89003C4.46233 6.08832 4.29882 6.4049 4.3023 6.74235V20.3099C4.3023 20.7065 4.52495 21.0649 4.87979 21.2423L11.0061 24.3037V7.52857L5.67645 5.75087C5.35988 5.64303 5.00851 5.69521 4.73368 5.89003ZM18.9137 5.67351L25.12 8.78014C25.4748 8.95756 25.6975 9.31936 25.6975 9.71595V23.2835C25.6975 23.3949 25.6801 23.5062 25.6453 23.6106C25.4609 24.1602 24.8695 24.4524 24.3233 24.2715L18.9137 22.4695V5.67351Z",
    fill: "#CDA876"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ4);
export default __webpack_public_path__ + "static/media/q4.37d2f753e7f45dba981396693e4a88a8.svg";
export { ForwardRef as ReactComponent };